import { configureStore } from "@reduxjs/toolkit";
import  foodReducer  from './reducers/foodItemReducer';
import authReducer from './reducers/authReducer';
import happyHourReducer from './reducers/happyHourReducer';
import cartReducer from './reducers/cartReducer';

 const store=configureStore({
    reducer: {
        food:foodReducer,
        auth:authReducer,
        cart: cartReducer,
        happyHour:happyHourReducer
    },
});
export default store